/**
 * O BTG só devolve `paymentDate` (sem hora). A hora vem embutida no endToEndId do PIX:
 * E + ISPB (8 dígitos) + AAAAMMDDHHmm (UTC) + sufixo.
 */
export const parseEndToEndDate = (endToEndId?: string | null): Date | null => {
  const match = endToEndId?.match(/^E\d{8}(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/);
  if (!match) return null;

  const [, year, month, day, hour, minute] = match;
  const date = new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute))
  );

  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * Data do PIX no BTG, sem hora (a hora do endToEndId é UTC e não é exibida).
 * Usa `paymentDate`; sem ele, cai para a data embutida no endToEndId.
 */
export const formatBtgDateTime = (
  paymentDate?: string | null,
  endToEndId?: string | null
): string | null => {
  if (paymentDate) {
    return new Date(paymentDate).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }

  const fromEndToEnd = parseEndToEndDate(endToEndId);
  return fromEndToEnd
    ? fromEndToEnd.toLocaleDateString("pt-BR", { timeZone: "UTC" })
    : null;
};
